import toJsonSchema from 'to-json-schema'

export default function convertJSONtoSchema(json) {
  return toJsonSchema(json, {
    postProcessFnc: (type, schema, value) => {
      let updatedSchema = schema

      if (type === 'array' && updatedSchema.items?.type === 'object') {
        updatedSchema = { ...updatedSchema.items, type: 'array' }
        delete updatedSchema.items
      }

      if (type !== 'array' && type !== 'object' && value) {
        updatedSchema.example = value.length >= 25 ? `${value.toString()?.slice(0, 25)}...` : value
      }
      return updatedSchema
    },
    arrays: { mode: 'first' },
    strings: {
      detectFormat: true,
      preProcessFnc: (value, defaultFnc) => {
        const schema = defaultFnc(value)
        const isDate = date => String(new Date(date)) !== 'Invalid Date' && !Number.isNaN(Number(new Date(date)))
        if (isDate(value)) {
          schema.format = 'date-time'
        }
        return schema
      }
    },
    objects: {
      preProcessFnc: (obj, defaultFnc) => {
        // undefined is not a valid json value,
        return defaultFnc(nullify(obj))
      }
    }
  })
}
const nullify = obj => {
  for (const key in obj) {
    if (obj[key] === undefined) {
      obj[key] = null
    } else if (typeof obj[key] === 'object') {
      obj[key] = nullify(obj[key])
    }
  }
  return obj
}
